import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  padding: ", ";\n  line-height: 1;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  padding-top: 0;\n  padding-bottom: 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  padding: 5px 0 2px 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import * as React from 'react';
import styled from 'styled-components';
import { AI2Logo } from '../logos/AI2Logo';
import Layout from '../layout'; // eslint-disable-next-line import/prefer-default-export

export var AI2Banner = React.forwardRef(function (_, ref) {
  return /*#__PURE__*/React.createElement(DarkBanner, {
    ref: ref
  }, /*#__PURE__*/React.createElement(BannerContent, null, /*#__PURE__*/React.createElement(BannerLink, {
    href: "https://allenai.org"
  }, /*#__PURE__*/React.createElement(AI2Logo, {
    color: "white",
    size: "micro"
  }))));
});
var BannerLink = styled.a(_templateObject());
var BannerContent = styled(Layout.Content)(_templateObject2());
var DarkBanner = styled.div(_templateObject3(), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.background.dark;
}, function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.spacing.xxs, " 0");
});